export default __webpack_public_path__ + "static/media/iPhone-X1.9ec315be.png";